import { HttpBackend, HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";
import { ZzzConfigService } from "src/app/zzz/core/config/config.service";
import { ReponseActionApiBase } from "src/app/zzz/core/shared/core.models";

@Injectable({
  providedIn: 'root'
})
export class ParametresService {
  #configService = inject(ZzzConfigService);
  #backend = inject(HttpBackend);
  #http = new HttpClient(this.#backend);

  get urlApi(): string {
    return this.#configService.get().authApiEndPoint;
  }

  obtenirValeur(codeParametre: string): Observable<ReponseValeurParametre> {
    const url = `${this.urlApi}/sigtapi/parametres/${codeParametre}`;
    return this.#http.get<ReponseValeurParametre>(url);
  }
}

export class ReponseValeurParametre extends ReponseActionApiBase {
  valeur: string;
}
